export default "__VITE_ASSET__G0_YKuHz__"